import { Component, OnDestroy, OnInit } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import { SaveCourtEventNoteSuccessAction } from '../../+store/court-event-note-save.actions';
import { CourtEventNoteSaveFacade } from '../../+store/court-event-note-save.facade';
import { CourtEventNoteSaveInputModel } from '../../models/court-event-note-save-input.model';
import { CourtEventNoteSaveFormService } from '../../services/court-event-note-save-form.service';

@Component({
    selector: 'app-court-event-note-save-modal',
    templateUrl: './court-event-note-save-modal.component.html',
    styleUrls: ['./court-event-note-save-modal.component.scss'],
    standalone: false
})
export class CourtEventNoteSaveModalComponent implements OnInit, OnDestroy {

    isFormValid$ = this.courtEventSaveNoteFacade.isFormValid$;
    isFormLoading$ = this.courtEventSaveNoteFacade.isFormLoading$;

    courtEventInput: CourtEventNoteSaveInputModel;

    form: UntypedFormGroup;

    private subscriptions: Subscription = new Subscription();

    constructor(public bsModalRef: BsModalRef,
        private courtEventSaveNoteFacade: CourtEventNoteSaveFacade,
        private formService: CourtEventNoteSaveFormService,
        private actions$: Actions) { }

    ngOnInit(): void {
        this.form = this.formService.initForm();

        this.subscriptions.add(
            this.actions$.pipe(ofActionSuccessful(SaveCourtEventNoteSuccessAction)).subscribe(() => {
                this.bsModalRef.hide();
            })
        );
    }

    ngOnDestroy(): void {
        this.courtEventSaveNoteFacade.resetCourtEventNoteForm();
        this.subscriptions.unsubscribe();
    }

    onSave(): void {
        this.courtEventSaveNoteFacade.saveCourtEventNote(this.courtEventInput.courtEventId);
    }
}
